import React from 'react';
import { FormGroup } from 'migration-flos-react';

const FieldWrapper = (props) => (
    <div className="col-xs-12 col-lg-12 row">
        <FormGroup>{props.children}</FormGroup>
    </div>
);

export default FieldWrapper;
